import { Maybe } from '../../../../../../common/schema/hannibal/types.generated';
import { SearchResultAddress } from '../../../../../types';
import { AddressView, Display, MonoPin, PinWrapper } from './Address.styles';
import { Distance } from './Distance/Distance';

interface Props {
  address: SearchResultAddress;
  distance?: number;
  onClick?: VoidFunction;
  url?: string;
}

const joinWhenNotNull = (joiner: string, parts: Maybe<unknown>[]) =>
  parts.filter(Boolean).join(joiner);

export const Address = ({ address, distance, onClick, url = '#' }: Props) => {
  const { street, suburb, streetNumber, state } = address;

  const formattedAddress = joinWhenNotNull(', ', [
    joinWhenNotNull(' ', [streetNumber, street]),
    suburb,
    state,
  ]);

  return (
    <AddressView onClick={onClick}>
      <PinWrapper>
        <MonoPin />
      </PinWrapper>
      <Distance distance={distance} />
      <Display to={url}>{formattedAddress}</Display>
    </AddressView>
  );
};
